const ABSOLUTE_MIDDLE = `
  transform: translate(0, -50%);
`;

const ABSOLUTE_CENTER = `
  transform: translate(-50%, 0);
`;

const ABSOLUTE_CENTER_MIDDLE = `
  transform: translate(-50%, -50%);
`;

const ROBOTO_TYPE = `
  font-face: "Roboto", sans-serif;
`;

export default {
  ABSOLUTE_CENTER,
  ABSOLUTE_CENTER_MIDDLE,
  ABSOLUTE_MIDDLE,
  ROBOTO_TYPE
};